import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css'; // Import the CSS file
import axios from 'axios'; // Import Axios for API calls

const List = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userData, setUserData] = useState([]); // State for user data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of users per page
  const history = useHistory();
  const token = localStorage.getItem('token'); // Ensure you retrieve the correct token from localStorage

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getall-users?page=${currentPage}&limit=${limit}&searchQuery=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        setUserData(response.data.users); // Assuming response.data contains the array of users
        setTotalPages(response.data.totalPages);
      } else {
        console.log("Error getting List");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleEdit = (id) => {
    history.push(`/edit/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://brand.aasmo.in/api/admin/delete-user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        fetchUserData(); // Refresh data after deletion
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false); // Close modal after deletion
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'First Name',
      'Last Name',
      'Contact No',
      'City',
      'Date',
    ];

    const csvRows = [];
    csvRows.push(headers.join(',')); // Add headers to the CSV

    userData.forEach((user, index) => {
      const row = [
        (currentPage - 1) * limit + index + 1, // S.No
        user.firstName, // First Name
        user.lastName,  // Last Name
        user.phoneNumber || 'N/A', // Contact No
        user.city || 'N/A', // City
        formatDate(user.createdAt), // Date (formatted)
      ];
      csvRows.push(row.join(','));
    });

    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'user_list.csv';
    link.click();
  };

  // Fetch user data from API
  useEffect(() => {
    fetchUserData();
  }, [currentPage, limit, searchQuery]); // Dependencies to refetch on page change, limit change or search query change

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List</h2>
        </div>
        <div className="body">
          <div className="d-flex justify-content-between">
            {/* Search Input */}
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by Name"
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>
            <div>
              <button onClick={handleDownloadCSV} className="btn btn-primary">
                Download CSV
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                <tr>
                  <th>S.No</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Contact No</th>
                  <th>City</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {userData.map((user, index) => (
                  <tr key={user.id}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>
                    <td>{user.firstName}</td>
                    <td>{user.lastName}</td>
                    <td>{user.phoneNumber}</td>
                    <td>{user.city}</td>
                    <td>{formatDate(user.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(user._id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user._id)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="body">
            <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </NavLink>
                </li>
                {[...Array(totalPages).keys()].map(page => (
                  <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                    <NavLink
                      to="#"
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </NavLink>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedUserId)}
      />
    </div>
  );
};

export default List;
